import {
	Box,
	Button,
	FormControl,
	Grid,
	InputLabel,
	MenuItem,
	Select,
	TextField,
	Typography,
} from "@mui/material";

import SearchIcon from "@mui/icons-material/Search";

import React from "react";
import { sizes } from "../scenarioSetupNewUtils";
import { useDispatch, useSelector } from "react-redux";
import { getProductGroup, setState } from "../scenarioSetupNewSlice";

const commonHeight = sizes.h35;
const SW = sizes.w300;

export default function SkuPgSearchForm() {
	const dispatch = useDispatch();
	const setupState = useSelector((store) => store.scenarioSetupNew);
	const {
		skuCategories,
		selectedSKUCategory,
		sku_PG_Name,
		selectedCountry,
		countryID,
	} = setupState;

	const handleSKUCategorySelection = (event) => {
		if (selectedCountry.length <= 0) {
			showMessage("Please select a country first", "info");
			return;
		}
		const value = event.target.value;
		dispatch(setState("selectedSKUCategory", value));
	};

	const handleSearchPG = () => {
		if (selectedCountry.length <= 0) {
			showMessage("Please select a country first", "info");
			return;
		}
		dispatch(setState("productGroups", []));
		dispatch(setState("is_sku_refresh", true));
		dispatch(getProductGroup({ countryID, sku_PG_Name }));
	};

	const handleStateUpdate = (event, stateName) => {
		const value = event.target.value;
		dispatch(setState(stateName, value));
	};

	const showMessage = (message, severity) => {
		dispatch(setState("message", message));
		dispatch(setState("severity", severity));
		dispatch(setState("messageOpen", true));
	};

	return (
		<Box
			sx={{
				mt: 4,
			}}
		>
			{/* <Box>
				<Typography variant="subtitle1" sx={{ color: "lightBlue.main", fontWeight: "bold", mb:4, }} className="compHeading">
					Select SKUs/Product Groups
				</Typography>
			</Box> */}
			<Grid container columns={12} columnSpacing={2} sx={{ mt: 3 }}
			//  maxWidth={"99%"}
			 >
				<Grid item sm={6} md={4.9} lg={5.5}>
					<Box>
						<FormControl sx={{width:"100%", mt: 1,}}>
							<InputLabel id="demo-simple-select-label">
								Select SKU Category
							</InputLabel>
							<Select
								labelId="demo-simple-select-label"
								id="demo-simple-select"
								value={selectedSKUCategory}
								label="Country"
								onChange={handleSKUCategorySelection}
								className="montserratFont"
							>
								{skuCategories.map((category, index) => {
									return (
										<MenuItem key={index} value={category}>
											{category}
										</MenuItem>
									);
								})}
							</Select>
						</FormControl>
					</Box>
				</Grid>
				<Grid item md={5} sm={4} lg={5.2}>
					<Box>
						<TextField sx={{width:"100%",mt: 1,}}
							id="outlined-basic"
							label="Search SKU / Product Group"
							variant="outlined"
							size="small"
							value={sku_PG_Name}
							onChange={(event) =>
								handleStateUpdate(event, "sku_PG_Name")
							}
						/>
					</Box>
				</Grid>
				<Grid sm={1.1} item>
					<Box>
						<Button
							startIcon={<SearchIcon />}
							sx={{
								bgcolor: "blue.main",
								color: "white.main",
								textTransform: "none",
								mt: 1,
								"&:hover": {
									bgcolor: "lightBlue.main",
								},
							}}
							onClick={handleSearchPG}
						>
							Search
						</Button>
					</Box>
				</Grid>
			</Grid>
		</Box>
	);
}
